const metrics = [
  {
    value: '3×',
    label: 'Faster lead response vs. manual follow-up',
    icon: 'ri-timer-flash-line',
  },
  {
    value: '85%',
    label: 'Average increase in qualified booking rates',
    icon: 'ri-bar-chart-2-line',
  },
  {
    value: '< 60s',
    label: 'AI response time to every inbound inquiry',
    icon: 'ri-reply-line',
  },
  {
    value: '2–3 wk',
    label: 'Average time from kickoff to live system',
    icon: 'ri-rocket-line',
  },
];

export default function StatsSection() {
  return (
    <section className="bg-[#0B2A4A] relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/162cb06a0e35d5bc19956992528e25ef.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B2A4A]/80 via-[#0B2A4A]/60 to-[#0B2A4A]/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 lg:px-16 py-28">
        {/* Top label */}
        <div className="text-center mb-20">
          <span className="text-xs tracking-widest uppercase text-white/35 font-medium">
            By the Numbers
          </span>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/8 rounded-2xl overflow-hidden border border-white/8">
          {metrics.map((m) => (
            <div
              key={m.value}
              className="bg-[#0B2A4A]/60 px-10 py-12 flex flex-col gap-4 hover:bg-white/5 transition-colors"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${m.icon} text-[#5EEAD4] text-xl`} />
              </div>
              <div className="text-5xl lg:text-6xl font-semibold text-white tracking-[-0.025em]">
                {m.value}
              </div>
              <p className="text-sm text-white/40 leading-relaxed tracking-wide">
                {m.label}
              </p>
            </div>
          ))}
        </div>

        {/* Caption */}
        <p className="text-center text-xs text-white/25 tracking-wide mt-10">
          Results based on client outcomes across insurance, real estate, and financial services.
        </p>
      </div>
    </section>
  );
}
